<template>
  <div>
    <div class="d-flex mb-2">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          NO：{{
            formData.resFabricRecordNo ? formData.resFabricRecordNo : '新增'
          }}
        </span>
        <el-divider direction="vertical"></el-divider>

        <el-tag
          size="small"
          :type="
            formData.resFabricRecordStatus === 'Y'
              ? 'success'
              : formData.resFabricRecordStatus === 'D'
              ? 'danger'
              : ''
          "
        >
          {{ formData.v_resFabricRecordStatus || '新增' }}
        </el-tag>

        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Modify：{{ formData.modifyByName ? formData.modifyByName : '--' }} at
          {{ formData.modifyDate ? formData.modifyDate : '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      size="mini"
      :disabled="disabled"
    >
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_person_name') || '调研人员'"
            prop="resPersonCode"
          >
            <dict-select
              size="mini"
              v-model="formData.resPersonCode"
              url="/master/common/dict/baseUserSelect"
              :selectedLabel.sync="formData.resPersonName"
              clearable
              filterable
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>

        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_date') || '调研日期'"
            prop="resDate"
          >
            <el-date-picker
              v-model="formData.resDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_scmName') || '供应商'"
            prop="resScmCode"
          >
            <dict-select
              size="mini"
              clearable
              filterable
              v-model="formData.resScmCode"
              url="/master/common/dict/scm"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_memo') || '调研说明'"
            prop="resMemo"
          >
            <el-input
              v-model="formData.resMemo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              maxlength="200"
              size="mini"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2" v-if="!disabled">
          <el-form-item :label="''">
            <br />
            <el-button
              type="primary"
              size="mini"
              @click="save()"
              style="width: 100%"
              >{{ $l('INDEX.btn_save') || '保存' }}</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <StoreTable
      :resFabricRecordCode="resFabricRecordCode"
      :disabled="disabled"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import StoreTable from '../store-table'
export default {
  mixins: [EditLoading],
  components: { StoreTable },
  props: {
    disabled: { type: Boolean, default: false },
    resFabricRecordCode: { type: String, default: '' },
  },
  watch: {
    info: {
      handler(userInfo) {
        const { userCode, userName } = userInfo || {}
        const { designCode, designName } = this.formData || {}
        this.formData = {
          ...this.formData,
          designCode: designCode || userCode,
          designName: designName || userName,
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState('admin/user', ['info']),
  },
  data() {
    return {
      formData: {
        defaultImageUrl: '',
        collectionNo: '',
        collectionName: '',
        designCode: '',
        designName: '',
      },

      chooseCollectionVisible: false,
      rules: {
        resPersonCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
        resDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
        resScmCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
        resMemo: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),

    getData() {
      if (!this.resFabricRecordCode) return
      this.$api
        .resFabricRecodeDetailApi({
          resFabricRecordCode: this.resFabricRecordCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },

    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      this.loadingOpen()
      this.$api
        .resFabricRecodeEditSaveApi(this.formData)
        .then(async (res) => {
          this.loadingClose()
          const { status, body } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          this.imageVisible = false

          const { resFabricRecordCode = '', resFabricRecordNo = '' } =
            body || {}
          if (resFabricRecordCode) {
            this.$router.replace({
              name: 'resourceManagement-research-detail',
              params: { code: resFabricRecordCode, pageType: 'edit' },
              query: { resFabricRecordNo },
            })
            return
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}

.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
}

.el-row {
  display: flex;
  align-items: stretch;
}
</style>
